/**
 * SweetAlert2 « Ki Para » — LE point d'entrée unique des popups du site.
 *
 * Brand kit §10 (Modales & panneaux, owner 2026-10-04 : « tous ces panneaux
 * comme notre brand kit ») : entête aplat encre + ✕, pied Annuler (ghost) à
 * gauche / action à droite. La FORME (largeur 420, rayon, entête, corps,
 * pied, boutons) vit dans index.css (« Popups SweetAlert2 ») ; ici seulement
 * ce que le CSS ne peut pas faire : le ✕ et l'ordre des boutons.
 *
 * Toujours `import Swal from '…/theme/swal'` — jamais 'sweetalert2' en direct.
 * Les toasts (`Swal.mixin({ toast: true })`) héritent sans dommage : le CSS
 * cache leur ✕.
 */
import Swal2 from 'sweetalert2';

const Swal = Swal2.mixin({
  showCloseButton: true,
  reverseButtons: true,
});

export default Swal;
